import clsx from 'clsx';
import { isString } from 'es-toolkit/compat';
import React from 'react';

import s from './FrameIcon.module.less';

type IconForm = 'circle' | 'square';

export interface Props {
  color?: string;
  className?: string;
  children: React.ReactNode;
  form?: IconForm;
  padding?: number | string;
}

const FrameIcon: React.FC<Props> = ({
  color = 'inherit',
  className = 'circle-icon-wrap',
  children,
  form = 'circle',
  padding = 0,
}) => {
  const composedClassName = clsx(s.root, className, {
    [s.circle]: form === 'circle',
    [s.square]: form !== 'circle',
  });

  const style: React.CSSProperties = {
    backgroundColor: color ?? 'inherit',
    padding: isString(padding) ? padding : `${padding}px`,
  };

  return (
    <span className={composedClassName} style={style}>
      {children}
    </span>
  );
};

export default FrameIcon;
